/*
    Vue Directive to implement 'v-focus', which will focus the element it is applied to when that element is mounted
*/

const focus = {
  mounted: (el) => el.focus(),
}

export default focus
